import type { PluginImportConfig } from '@squaredup/plugins';
import React, { createContext, useContext, useState, type Dispatch, type SetStateAction } from 'react';

type PluginImportConfigEditorContextValue = PluginImportConfig & {
    configId: string;
    setConfig: Dispatch<SetStateAction<PluginImportConfig>>;
};

const PluginImportConfigEditorContext = createContext<PluginImportConfigEditorContextValue>({
    tileConfig: { _type: 'tile/data-stream' },
    sourceNameColumn: '',
    sourceIdColumn: '',
    sourceType: {
        mode: 'fixed',
        value: undefined,
        column: undefined
    },
    columnMapping: {},
    configId: '',
    setConfig: () => undefined
});

export const usePluginImportConfigEditorContext = () => useContext(PluginImportConfigEditorContext);

type PluginImportConfigEditorContextWrapperProps = {
    config: PluginImportConfig;
    configId: string;
};

export const PluginImportConfigEditorContextWrapper: React.FC<PluginImportConfigEditorContextWrapperProps> = (
    props
) => {
    const [config, setConfig] = useState(props.config);

    return (
        <PluginImportConfigEditorContext.Provider
            value={{
                ...config,
                configId: props.configId,
                setConfig
            }}
        >
            {props.children}
        </PluginImportConfigEditorContext.Provider>
    );
};
